import React,{ useState,useEffect } from 'react';
import DatePicker from "react-datepicker";
/* import { ko } from 'date-fns/esm/locale'; */
import "react-datepicker/dist/react-datepicker.css";
import {addThousandPoint, removeThousandPoint,ChangeDateFormat, isObjEmpty} from "../../../components/common/Common";

const SettlementLines = ({varSettleData,varSettlementOtherList,setSettlementOtherList,varSettlementSerious}) => {

  const [varSupplyDate,setSupplyDate] = useState(varSettleData.stl_sdate===null?null:varSettleData.stl_sdate);
  const [varSettlementData,setSettlementData] = useState({});

  useEffect(() => {
    setSettlementData(varSettleData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //입력값 변경
  const onChangeInputHandler = (e) => {
    const { name,value } = e.currentTarget;
    let svalue = value;
    if(name === 'stl_price' || name === 'stl_amount'){
      svalue = Number(removeThousandPoint(value));
    } else if(name === 'stl_numb' || name === 'stl_vs_idx'){
      svalue = Number(value);
    } 
    setSettlementData({...varSettlementData,[name]:svalue});
  }

  //입력취소
  const onDeleteLineHandler = async(e) => {
    if(varSettlementData.stl_idx === 0) { //임시저장분
      const copyData = varSettlementOtherList.filter(el=>el.stl_idx!==varSettlementData.stl_idx && el.stl_status!==varSettlementData.stl_status);
      setSettlementOtherList(copyData);
    } else {
      const copyData = [...varSettlementOtherList];
      const findIndex = copyData.findIndex(el=>el.stl_idx===varSettlementData.stl_idx);
      copyData[findIndex]['stl_status'] = 0;
      setSettlementOtherList(copyData);
    }
  }

  //입력저장
  const onUpdateLineHandler = (e,index) => {
    const copyInfo = {...varSettlementData};
    copyInfo.stl_status = 1;
    const copyList = [...varSettlementOtherList];
    let findIndex = 0;
    if(varSettlementData.stl_idx === 0){
      findIndex = copyList.findIndex(el=>el.index===index);
    } else {
      findIndex = copyList.findIndex(el=>el.stl_idx===varSettlementData.stl_idx);
    } 
    copyList[findIndex] = copyInfo;
    setSettlementOtherList(copyList);
    alert('내역을 임시저장했습니다.');
  }

  //제공일자 저장
  const onChangeDateHandler = (date) => {
    if(date === "" ) date = null;
    const stl_sdate = ChangeDateFormat(date);
    setSettlementData({...varSettlementData,stl_sdate:stl_sdate});
    setSupplyDate(date);
  }

  return isObjEmpty(varSettlementData)?null:(
    <tr>
      <td style={{paddingLeft:"0px",textAlign:"left"}}>
        <select name="stl_vs_idx" value={varSettlementData.stl_vs_idx} onChange={e=>onChangeInputHandler(e)}>
          <option value={0}>선택</option>
          {varSettlementSerious.map((serious,i)=>(
            <option key={'serious_'+i} value={serious.vs_idx}>{serious.vs_name}</option>
          ))}
        </select>
      </td>
      <td style={{padding:"8px 5px",textAlign:"left"}}>
        <input type="text" name="stl_info" value={varSettlementData.stl_info} onChange={e=>onChangeInputHandler(e)} />
      </td>
      {varSettlementData.stl_vs_idx!==3?<td></td>:
        <td style={{padding:"8px 5px",textAlign:"center"}}>
          <input type="text" name="stl_numb" value={varSettlementData.stl_numb} onChange={e=>onChangeInputHandler(e)} />
        </td>
      }
      {/* {varSettlementData.stl_vs_idx===3?
        <td style={{padding:"8px 5px",textAlign:"right"}}>
          <input type="text" name="stl_price" value={addThousandPoint(varSettlementData.stl_price)} onChange={e=>onChangeInputHandler(e)} />
        </td>
      : */}
        <td style={{padding:"8px 5px",textAlign:"right"}}>
          <input type="text" name="stl_amount" value={addThousandPoint(varSettlementData.stl_amount)} onChange={e=>onChangeInputHandler(e)} />
        </td>
     {/*  } */}
      <td style={{padding:"8px 5px",textAlign:"center"}}>
      <DatePicker name="stl_sdate" className="datepicker" dateFormat="yyyy.MM.dd" selected={varSupplyDate} onChange={(date)=>onChangeDateHandler(date)} />
      </td>
      <td style={{padding:"8px 0px 8px 5px",textAlign:"right"}}>
      <button className="btn line" onClick={e=>onUpdateLineHandler(e,varSettlementData.index)}>{varSettlementData.stl_status===-1?"등록":"저장"}</button>
        <button className="btn line" onClick={e=>onDeleteLineHandler(e)}>삭제</button>
      </td>
    </tr>
  )
}
export default SettlementLines;